export default "__VITE_ASSET__8fd07a20__"